import React, { FC } from 'react';
import { useParams } from 'react-router';
import SeriesListContainer from './SeriesListContainer';
import { SeriesDetailContent } from '../SeriesDetail/index';
import { ExerciseSeriesType } from '../../../../config/api/models/Exercise';
import WorkSheet from './WorkSheet';
import { UrlParams } from '../../../shared/types';
import { WorkSheetWrapper, ExerciseListBlockWrapper } from './Atoms';
import { BlocksList } from './BlocksList';
import { usePagesByType } from '../../hooks';
import { TrajectorySectionOrWorksheetType } from 'src/config/api/models/Trajectory';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';

type Props = {
  type: ExerciseSeriesType;
  isTrajectoryViewEditMode?: boolean;
};

const TrajectoryExercisesEvaluationBuilder: FC<Props> = ({
  type,
  isTrajectoryViewEditMode = false,
}) => {
  const { seriesId } = useParams<UrlParams>();
  const worksheetPages = usePagesByType(`worksheet_${type}` as TrajectorySectionOrWorksheetType);
  const blocks = useAppSelector((state) => state.blocks.blocks);

  if (seriesId) {
    return (
      <>
        <SeriesDetailContent
          isTrajectoryViewEditMode={isTrajectoryViewEditMode}
          seriesId={seriesId}
          type={type}
        />
        {!!worksheetPages.data && worksheetPages.data.length > 0 && blocks && (
          <ExerciseListBlockWrapper>
            <BlocksList
              blocks={blocks.length > 1 ? [...blocks].splice(1) : blocks}
              pageType={type}
              pageId={worksheetPages?.data?.[0].id as string}
            />
          </ExerciseListBlockWrapper>
        )}
      </>
    );
  }

  return (
    <>
      <SeriesListContainer isTrajectoryViewEditMode={isTrajectoryViewEditMode} type={type} />
      <WorkSheetWrapper>
        <WorkSheet type={type} />
      </WorkSheetWrapper>
    </>
  );
};

export default TrajectoryExercisesEvaluationBuilder;
